import React from 'react';
import { UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { NewButton } from 'components/Button/NewButton/NewButton';
import Text from 'components/Text/Text';

interface IProps {
	onClick: () => void;
}

export const FullInfoBtn: React.FC<IProps> = ({ onClick }) => {
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	return (
		<NewButton size="small" disabled={!hasAccess} testId="FullInfoBtn" onClick={onClick}>
			<Text translationKey="fullInfoButton" translationNameSpace="listing" asFragment={true} />
		</NewButton>
	);
};
